import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
import { useEffect, useState } from "react";

const IslamicCalendar1 = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get("https://ecom.cyberathon.com/index.php/Api/list_calender");
        const apiEvents = response.data.events || [];

        // Transform API events to FullCalendar format
        const formattedEvents = apiEvents.map(event => ({
          title: event.title,
          start: event.gregorian_date, // FullCalendar requires 'start' for date
          extendedProps: {
            hijri: event.hijri_date,
            description: event.description
          }
        }));

        setEvents(formattedEvents);
      } catch (error) {
        console.error("Error fetching calendar events:", error);
      }
    };

    fetchEvents();
  }, []);

  const handleDateClick = (info) => {
    console.log("Clicked date:", info.dateStr);
    // Optionally open modal for admin to add new event
  };

  const handleEventClick = (info) => {
    alert(`
${info.event.title}
Hijri: ${info.event.extendedProps.hijri}
Description: ${info.event.extendedProps.description}
    `);
  };

  return (
    <FullCalendar
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={events}
      fixedWeekCount={true}   // 🔥 FORCE full 6 rows
  
      dateClick={handleDateClick}
      eventClick={handleEventClick}
      height="auto"
    />
  );
};

export default IslamicCalendar1;
